import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { buildLoginUrl } from "../utils/authRedirect";
import { useResolvedOrgContext } from "../context/ResolvedOrgContext";

export default function RequireAuth({ children }) {
  const location = useLocation();
  const orgContext = useResolvedOrgContext();
  const [loading, setLoading] = useState(!auth.currentUser);
  const [user, setUser] = useState(auth.currentUser);

  useEffect(() => {
    return onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#f7f3ea] px-6 py-20 text-center text-slate-700">
        Loading secure access...
      </div>
    );
  }

  if (!user) {
    return <Navigate to={buildLoginUrl(location, {orgSlug: orgContext?.orgSlug})} replace state={{ from: location }} />;
  }

  return children;
}
